import { memo } from 'react'

import { ArrowRightIcon, CheckIcon, Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { pushDataLayer } from 'utils/push-data-layer'

import { ProductTab } from '../products.model'

import * as S from './styles'

type Props = ProductTab

export const TabContent = memo(({ image, alt, features, link, cta, ariaLabel, dataLayer }: Props) => (
  <S.Panel>
    <S.Illustration>
      <NextImage
        src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home/products/${image}`}
        alt={alt}
        fill
        sizes="(max-width: 767px) 90vw, 40vw"
        style={{ objectFit: 'contain' }}
      />
    </S.Illustration>

    <S.Info>
      <S.Features>
        {features.map(feature => (
          <li key={feature}>
            <CheckIcon size={20} color="var(--colors-cyan-icon-default)" />
            <Text color="var(--colors-neutral-text-contrast-default)">{feature}</Text>
          </li>
        ))}
      </S.Features>

      <S.SaibaMais href={link} aria-label={ariaLabel} onClick={() => pushDataLayer(dataLayer)}>
        {cta}
        <ArrowRightIcon size={20} color="var(--colors-neutral-text-contrast-default)" />
      </S.SaibaMais>
    </S.Info>
  </S.Panel>
))

TabContent.displayName = 'TabContent'
